import { IconButton, Typography } from '@mui/material'
import React from 'react'
import {useTypewriter} from "react-simple-typewriter"

const MainSkills = () => {
    const [typeEffect] = useTypewriter({
        words:["Hi , i m Hafeez" ,"Software Developer", "Mobile App Developer", "CRMS Developer","Backend Developer","CRMS software Developer"],
        loop:{},
        typeSpeed:100,
        deleteSpeed:20
    })

  return (
    <div>
<Typography variant='h3' className="textTpe clr" id='txt_type' sx={{color:'#31F711'}}>
     {typeEffect} 
      <span className='clr'>|</span> </Typography>
    </div>
  )
}

export default MainSkills
